<script>
export default {
  props: ['name', 'label'],
  computed: {
    active () {
      if (this.$parent.$options.name === 'tabs') {
        return this.name === this.$parent.value
      }
      return false
    }
  }
}
</script>

<template>
  <div class="tab-pane" v-show="active">
    <slot></slot>
  </div>
</template>

<style lang="stylus"></style>
